import { apiUrls } from './index';
import { http } from './fetch-wrapper';
// create call
export function createCall(cid, fcid = null, _isPro = false, authData, callerJID, callProtocolVersion) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  const createCallRequest = {
    objectId: (typeof fcid === 'number' || typeof fcid === 'string')
      ? typeof fcid === 'number' ? fcid : Number.parseInt(fcid, 10)
      : null,
    signalingProtocol: callProtocolVersion,
    userId: cid,
    resourceId: callerJID,
  };

  // const additionalQuery = isPro ? `?cid=${cid}&isPro=${isPro}${fcid !== null ? `&fcid=${fcid}` : ''}` : `?cid=${cid}${fcid !== null ? `&fcid=${fcid}` : ''}`;
  return http(apiUrls.CALLS_V3, { method: 'POST', headers, body: JSON.stringify(createCallRequest) });
}

export function reviewCall(id, rating, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  return http(`${apiUrls.CALLS}/${id}/review`, { method: 'POST', headers, body: JSON.stringify({ rating }) });
}

export function getProFeatureService(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.FEATURED, { method: 'GET', headers });
}

export function sendNotificationFromSupport(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');
  return http(apiUrls.SEND_NOTIFICATION_FROM_SUPPORT(40), { method: 'POST', headers });
}



// WEBPACK FOOTER //
// ./api/chat.js